import React from 'react';

function Contact() {
  return (
    <section id="contact">
      <h2>Contact Us</h2>
      <p>Email: support@crawford-bank.ca<br/>Phone: </p>
    </section>
  );
}

export default Contact;
